import { api } from "@/api";
export const analyticsStore = {
  state: {
    events: [],
    defaultEvents: []
  },
  getters: {
    getEvents(state) {
      return state.events;
    },
    getUniqueNameEvents(state) {
      return [...new Set(state.events.map(x => x.name))];
    }
  },
  mutations: {
    setEvents(state, value) {
      state.events = value;
    },
    addEvent(state, value) {
      state.events.push(value);
    },
    removeEvent(state, value) {
      state.events = state.events.filter(x => x.id !== value.id);
    }
  },
  actions: {
    async loadEvents(context) {
      const res = await api.getEvents();
      const resD = await api.getDefaultEvents();
      context.commit("setEvents", [...res, ...resD]);
    },
    async postEvent(context, payload) {
      const res = await api.postEvent(payload);
      context.commit("addEvent", res);
    },
    async updateEvent(context, payload) {
      const res = await api.updateEvent(payload.id, payload);
      context.commit("removeEvent", res);
      context.commit("addEvent", res);
    },
    async deleteEvent(context, payload) {
      await api.deleteEvent(payload.id);
      context.commit("removeEvent", payload);
    }
  }
};
